import React from "react";

interface Props {
    text: string;
    subHeader?: boolean;
    style?: React.CSSProperties;
}

const KycHeader = (props: Props) => {
    const { subHeader, style, text } = props;
    return (
        <h4
            style={{
                fontWeight: 500,
                color: "#646363",
                fontSize: subHeader ? "14px" : "18px",
                marginBottom: 0,
                padding: "8px",
                ...style,
            }}
            tabIndex={0}
        >
            {text}
        </h4>
    );
};

export default KycHeader;



// WEBPACK FOOTER //
// ./src/components/form/QuestionParameters/KycHeader.tsx